import PhoneNumberPattern from '../enums/phone-number-pattern';
import isPhoneNumber from './is-phone-number';
function formatPhoneNumber(phoneNumber) {
  if (isPhoneNumber(phoneNumber)) {
    var ausNumber = phoneNumber.trim().replace(/\s/g, '');
    ausNumber = ausNumber.replace('+6113', '13');
    ausNumber = ausNumber.replace('+6118', '18');
    ausNumber = ausNumber.replace('+61', '0');
    if (ausNumber.match(PhoneNumberPattern.SMART_NUMBER_A)) {
      return "".concat(ausNumber.slice(0, 2), " ").concat(ausNumber.slice(2, 4), " ").concat(ausNumber.slice(4));
    }
    if (ausNumber.match(PhoneNumberPattern.SMART_NUMBER_B) || ausNumber.match(PhoneNumberPattern.SMART_NUMBER_C)) {
      return "".concat(ausNumber.slice(0, 4), " ").concat(ausNumber.slice(4, 7), " ").concat(ausNumber.slice(7));
    }
    if (ausNumber.match(PhoneNumberPattern.MOBILE)) {
      return "".concat(ausNumber.slice(0, 4), " ").concat(ausNumber.slice(4, 7), " ").concat(ausNumber.slice(7));
    }
    if (ausNumber.match(PhoneNumberPattern.LANDLINE_WITH_AREA)) {
      return "".concat(ausNumber.slice(0, 2), " ").concat(ausNumber.slice(2, 6), " ").concat(ausNumber.slice(6));
    }
    if (ausNumber.match(PhoneNumberPattern.LANDLINE_NO_AREA)) {
      return "".concat(ausNumber.slice(0, 4), " ").concat(ausNumber.slice(4));
    }
  }
  return phoneNumber;
}
export default formatPhoneNumber;